export const blogPosts = [
  {
    id: 1,
    slug: "building-with-clarity",
    date: "2026-01-07",
    title: {
      en: "Building With Clarity: How Quivio Frames Complex Work",
      fr: "Construire avec clarté : comment Quivio cadre le travail complexe",
    },
    summary: {
      en: "A short look at our discovery rituals, technical choices, and how we keep delivery predictable.",
      fr: "Un aperçu de nos rituels de découverte, de nos choix techniques et de notre approche de livraison prévisible.",
    },
    category: {
      en: "Insights",
      fr: "Perspectives",
    },
    format: "markdown",
    content: "/blog-content/building-with-clarity.md",
  },
  {
    id: 2,
    slug: "semantic-software-design",
    date: "2026-01-08",
    title: {
      en: "Semantic Software Design and Beautiful Architecture",
      fr: "Conception logicielle semantique et architecture harmonieuse",
    },
    summary: {
      en: "How shared language and coherent structure turn complex systems into products people can trust.",
      fr: "Comment un langage commun et une structure coherente transforment les systemes complexes en produits fiables.",
    },
    category: {
      en: "Principles",
      fr: "Principes",
    },
    format: "markdown",
    content: "/blog-content/semantic-software-design.md",
  },
  {
    id: 3,
    slug: "quivio-enclave",
    date: "2026-04-10",
    title: {
      en: "Introducing Quivio Enclave KMS",
      fr: "Présentation de Quivio Enclave KMS",
    },
    summary: {
      en: "A secure on-prem knowledge management system for governed AI, RBAC, citations, and auditability.",
      fr: "Un système de gestion des connaissances sur site pour l'IA gouvernée, le RBAC, les citations et l'auditabilité.",
    },
    category: {
      en: "Product",
      fr: "Produit",
    },
    format: "markdown",
    content: "/blog-content/quivio-enclave.md",
    contentFr: "/blog-content/quivio-enclave.fr.md",
  },
];
